__turbopack_context__.v({
  "className": "QcBcLW_className",
  "variable": "QcBcLW_variable",
});
